import React from 'react';
import { DashboardLayout } from 'src/skins/mars/components/layouts';
import { BuyElectricityForm } from 'src/skins/mars/forms';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { MarsModal } from 'src/skins/mars/components/common';

const Wrapper = styled.div`
  section {
    margin: 1rem 0;
  }
`;

const BillsElectricity = () => {
  const history = useHistory();
  return (
    <DashboardLayout>
      <MarsModal isOpen={true} closeModal={() => history.goBack()} fullheight={true} backgroundPage="bills">
        <Wrapper>
          <h2>Buy Electricity</h2>

          <section>
            <BuyElectricityForm />
          </section>
        </Wrapper>
      </MarsModal>
    </DashboardLayout>
  );
};

export default BillsElectricity;
